// extracted by mini-css-extract-plugin
export var clickThrough = "_yt-2";
export var fallback = "_yt-5";
export var frame = "_yt-3";
export var frameCell = "_yt-1";
export var overlay = "_yt-4";
export var wrapper = "_yt-0";